import * as classNames from "classNames";
import * as React from "react";
import { useState } from "react";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { ITableConfig } from "../Table";
import { getValueByKey } from "../Utils/TableUtils";
import { TableCell } from "./TableCell";
import { TableExpand } from "./TableExpand";

export interface ITableRowProps {
    data: any;
    col: ITableConfig[];
    index: number;
    style?: any;
    cssWrapper?: string;
    tdCssWrapper?: string;
    rowCssWrapper?: string;
    draggable?: boolean;
    onMove?: (e: React.DragEvent<HTMLDivElement>) => void;
    onDrop?: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const TableRow = (props: ITableRowProps) => {
    if (!props.col || !props.data) {return null;}
    const [toogle, setToogle] = useState(false);

    const renderTableExpand = (col: ITableConfig[], rowData, index) => {
        const { expandContent } = col[0].toogleOptions(rowData, index);
        return <TableExpand length={col.length}>{expandContent}</TableExpand>;
    };

    return (
        <>
            <tr
                id={`${props.index.toString()}`}
                style={props.style}
                className={props.rowCssWrapper}
                draggable={props.draggable}
                onDragStart={(e: React.DragEvent<HTMLDivElement>) => {
                    (e.currentTarget.childNodes[0] as HTMLElement).style.opacity = "0.2";
                }}
                onDrag={(e) => {
                    if (props.onMove) {props.onMove(e);}
                }}
                onDrop={(e) => {
                    e.preventDefault();
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                }}
                onDragEnd={(e) => {
                    if (props.onDrop) {props.onDrop(e);}
                }}
            >
                {props.col.map((ele, i) => {
                    if (ele.toogleOptions && ele.toogleOptions(props.data, props.index).toogleable) {
                        const { isToogle, onToogle } = ele.toogleOptions(props.data, props.index);
                        const _isToogle = CommonHelper.isNullOrEmpty(isToogle) ? toogle : isToogle;
                        return (
                            <td key={`td-${i}`} className={props.tdCssWrapper} colSpan={ele.colSpan}>
                                <div className="row no-wrap narrow-gutter">
                                    <div className="col-auto col-middle">
                                        <button
                                            className={`te-expand-btn`}
                                            aria-expanded={_isToogle}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setToogle(!toogle);
                                                if (onToogle) {onToogle(!_isToogle);}
                                            }}
                                        >
                                            <span className="sr-only">Click to expand details for this row</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                    <div className="col-fluid cell-primary col-middle is-expandable-row">
                                        <TableCell
                                            i={i}
                                            rowIndex={props.index}
                                            config={ele}
                                            data={props.data}
                                            tdCssWrapper={props.tdCssWrapper}
                                        />
                                    </div>
                                </div>
                            </td>
                        );
                    }
                    return (
                        <TableCell
                            key={i}
                            i={i}
                            rowIndex={props.index}
                            config={ele}
                            data={props.data}
                            tdCssWrapper={props.tdCssWrapper}
                        />
                    );
                })}
            </tr>
            {toogle && renderTableExpand(props.col, props.data, props.index)}
        </>
    );
};
